<template>
  <div class="web">
    <div class="canvas" @click="clickWeb">
      <div style="position: absolute; width: 0px; height: 0px; visibility: hidden; display: none;"></div>
      <div style="border-radius: 8px;">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 44"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          style="border-radius: 8px 8px 0px 0px; background-color: rgb(232, 232, 232);">
          <defs>
            <rect id="a" x="90" y="10" width="173.7" height="24" rx="4" fill="#FFF">
            </rect>
            <filter x="-.1%" y="-1.7%" width="100.2%" height="103.4%" filterUnits="objectBoundingBox" id="b">
              <feOffset dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
              <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1"
                result="shadowInnerInner1"></feComposite>
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" in="shadowInnerInner1"></feColorMatrix>
            </filter>
          </defs>
          <g fill="none" fill-rule="evenodd">
            <rect width="100%" fill="#e8e8e8"></rect>
            <use fill="#FFF" xlink:href="#a"></use>
            <use fill="#000" filter="url(#b)" xlink:href="#a"></use>
            <circle stroke="#F04744" fill="#FF5F56" fill-rule="nonzero" cx="20" cy="22" r="6"></circle>
            <circle stroke="#EBA03F" fill="#FFBD2E" fill-rule="nonzero" cx="40" cy="22" r="6"></circle>
            <circle stroke="#13AB42" fill="#27C93F" fill-rule="nonzero" cx="60" cy="22" r="6"></circle>
          </g>
          <text 
            x="95" y="29"
            fill="black" font-size="19"
            font-weight="bold">
            {{name}}
          </text>
        </svg>
        <img 
          class="web-image"
          :alt="name"
          :src="src"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Web',
    data: () => {
      return {}
    },
    props: {
      name: String,
      src: String
    },
    methods: {
      clickWeb() {
        this.$emit("clickWeb")
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.web {
  font-size: 0;
}
.web:hover {
  cursor: pointer;
}
.canvas {
  background-image: none;
  box-sizing: border-box;
  border-radius: 0px;
}
img {
  border-radius: 0px 0px 8px 8px;
  /* width: 100%; */
  border-style: none;
}
</style>